import React from 'react';
import {
  AUDIENCE_STUDIO,
  OAUTH_URLS,
  SEGMENT_MANAGER,
} from '../../content';
import { KDSPageNames } from 'constants/index';
import {
  NavigationItem,
  NavigationItemLabel,
  NavigationWrapper,
} from './index.styles';
import {
  SupervisedUserCircleRounded,
  TableChart,
  VpnKey,
} from '@material-ui/icons';
import { useRouteMatch } from 'react-router-dom';

const Navigation: React.FC = () => {
  const { url } = useRouteMatch();

  return (
    <NavigationWrapper>
      <NavigationItem to={`${url}/${KDSPageNames.AUDIENCESTUDIO}`}>
        <SupervisedUserCircleRounded style={{ color: 'white' }} />
        <NavigationItemLabel>{AUDIENCE_STUDIO}</NavigationItemLabel>
      </NavigationItem>
      <NavigationItem to={`${url}/${KDSPageNames.SEGMENT_MANAGER}`}>
        <TableChart style={{ color: 'white' }} />
        <NavigationItemLabel>{SEGMENT_MANAGER}</NavigationItemLabel>
      </NavigationItem>
      <NavigationItem to={`${url}/${KDSPageNames.OAUTH_URLS}`}>
        <VpnKey style={{ color: 'white' }} />
        <NavigationItemLabel>{OAUTH_URLS}</NavigationItemLabel>
      </NavigationItem>
    </NavigationWrapper>
  );
};

export default Navigation;
